import KeenSlider from "keen-slider";

/**
 * Popup gallery desktop and mobile init
 */
function popGalleryInit() {
  let gallCloseEle = document.querySelectorAll(".close-pop-gall");
  let gallMobileEle = document.querySelector("#popup_gallery_mobile");
  let gallDesktopEle = document.querySelector("#popup_gallery_desktop");
  let popGallSliderEle = document.querySelector("#pdp_gall_slider_mob");
  let pdpGallTriggerEle = document.querySelectorAll(".pop-gallery-trigger");
  let thumbImgWrapperEle = document.querySelectorAll(
    ".popup-thumb-img-wrapper"
  );
  let gallMainImgWrapperEle = document.querySelector("#main_img_desktop");
  let slider;

  // mobile popup gallery slider
  if (popGallSliderEle) {
    slider = new KeenSlider(
      popGallSliderEle,
      {
        loop: true,
        breakpoints: {
          "(min-width: 768px)": {
            disabled: true,
          },
        },
      },
      [popGallSlider]
    );
  }

  // Popup gallery listener
  pdpGallTriggerEle.forEach((ele) =>
    ele.addEventListener("click", (e) => {
      let clickedImgContEle = e.target.parentElement.closest(
        ".pop-gallery-trigger"
      );
      let clickedIndex = Number(clickedImgContEle?.dataset.index);
      changeGallIndex(slider, clickedIndex);
      updatePopupGallery(clickedIndex);
    })
  );

  /**
   * Changing gallery slider slides and show gallery
   * @param {object} slider - Keen slider object
   * @param {Number} index - index to change the slider
   */
  function changeGallIndex(slider, index) {
    if (slider) {
      slider.moveToIdx(index, false, {
        duration: 0,
      });
    }
    galleryVisibility(true, gallMobileEle);
  }

  /**
   * Update desktop popup gallery
   * @param {Number} index - slider slide index
   */
  function updatePopupGallery(index) {
    thumbImgWrapperEle[index].click();
    galleryVisibility(true, gallDesktopEle);
  }

  // Close gallery popup
  gallCloseEle.forEach((ele) =>
    ele.addEventListener("click", (e) => {
      galleryVisibility(false, gallMobileEle);
      galleryVisibility(false, gallDesktopEle);
      controlBodyScroll(false);
    })
  );

  // Update mobile gallery when change in desktop gallery
  thumbImgWrapperEle.forEach((ele) => {
    ele.addEventListener("click", (e) => {
      thumbImgWrapperEle.forEach((ele) => ele.classList.remove("active"));
      ele.classList.add("active");
      changeGallMainImg(ele);
      let index = Number(ele.dataset.index);
      changeGallIndex(slider, index);
    });
  });

  /**
   * Change desktop popup image
   * @param {Element} element - image source element
   */
  function changeGallMainImg(element) {
    let image = element.dataset.imagesrc;
    gallMainImgWrapperEle.style.backgroundImage = `url('${image}')`;
    gallMainImgWrapperEle.querySelector("img").src = image;
  }

  // mobile slider controls and navigation
  function popGallSlider(slider) {
    let wrapper, arrowLeft, arrowRight;

    const observer = new ResizeObserver(function () {
      slider.update();
    });

    function markup(remove) {
      wrapperMarkup(remove);
      arrowMarkup(remove);
    }

    function removeElement(elment) {
      elment.parentNode.removeChild(elment);
    }
    function createDiv(className) {
      var div = document.createElement("div");
      var classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }

    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }
      arrowLeft = createDiv("arrow arrow--left");
      arrowLeft.addEventListener("click", () => slider.prev());
      arrowRight = createDiv("arrow arrow--right");
      arrowRight.addEventListener("click", () => slider.next());

      wrapper.appendChild(arrowLeft);
      wrapper.appendChild(arrowRight);
    }

    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode;
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      wrapper = createDiv("navigation-wrapper");
      slider.container.parentNode.appendChild(wrapper);
      wrapper.appendChild(slider.container);
    }

    function updateClasses() {
      var slide = slider.track.details.rel;
      slide === 0
        ? arrowLeft.classList.add("arrow--disabled")
        : arrowLeft.classList.remove("arrow--disabled");
      slide === slider.track.details.slides.length - 1
        ? arrowRight.classList.add("arrow--disabled")
        : arrowRight.classList.remove("arrow--disabled");
    }

    slider.on("created", (e) => {
      markup();
      updateClasses();
      observer.observe(slider.container);
    });
    slider.on("optionsChanged", () => {
      markup(true);
      markup();
      updateClasses();
    });
    slider.on("slideChanged", (e) => {
      updateClasses();
      let index = e.track.details.abs;
      thumbImgWrapperEle[index]?.click();
    });
    slider.on("destroyed", () => {
      markup(true);
      observer.observe(slider.container);
    });
  }

  /**
   * Contol element visibility with status
   * @param {Boolean} status - show or hide element
   * @param {Element} ele - Element for visibility change
   */
  function galleryVisibility(status, ele) {
    ele.classList.remove("active");
    if (status) {
      ele.classList.add("active");
    } else {
      ele.classList.remove("active");
    }

    // lock body scroll
    controlBodyScroll(true);

    // desktop scroll listener fire only on desktop
    if (ele.classList.contains("desktop-popup-gallery")) {
      desktopScrollEffect(gallDesktopEle);
    }
  }

  /**
   * Control body scroll lock
   * @param {Boolean} statue - lock scroll status
   */
  function controlBodyScroll(statue) {
    if (statue) {
      document.body.classList.add("lock-scroll");
    } else {
      document.body.classList.remove("lock-scroll");
    }
  }

  // Desktop scroll effect
  function desktopScrollEffect() {
    let backgroundDiv = gallDesktopEle.querySelector("#popup_hover_cont");
    let image = gallDesktopEle.querySelector("#main_img_desktop");
    let parentElementDesk = document.querySelector(
      "#popup_gallery_wrapper_desktop"
    );
    let calcVerticalSpace = (40 / parentElementDesk.clientHeight) * 100;
    //calcVerticalSpace = 4.5;

    backgroundDiv.addEventListener("mousemove", (event) => handleMove(event));
    backgroundDiv.addEventListener("touchmove", (event) => handleMove(event));

    function handleMove(event) {
      let clientLoc = event.clientY || event.touches[0].clientY;
      let mouseY = clientLoc - backgroundDiv.getBoundingClientRect().top;
      let divHeight = backgroundDiv.clientHeight;

      let percentage = (mouseY / divHeight) * 100;
      if (percentage > 0 && percentage < 100) {
        //image.style.backgroundPositionY = `${percentage}%`;
        if (percentage < 3) {
          image.style.backgroundPositionY = `${
            percentage - calcVerticalSpace
          }%`;
        } else if (percentage > 97) {
          image.style.backgroundPositionY = `${
            percentage + calcVerticalSpace
          }%`;
        } else {
          image.style.backgroundPositionY = `${percentage}%`;
        }
      }
    }
  }
}
popGalleryInit();
